import { FC } from 'react';
import { ICardAnalyticItemProps, CardTheme } from './cardAnalytic/types';

interface InternalDashboardCardProps {
  item: ICardAnalyticItemProps;
  isLoading: boolean;
}

const getThemeBackgroundColor = (theme: CardTheme): string => {
  switch (theme) {
    case CardTheme.RED:
      return '#FFE5E5';
    case CardTheme.ORANGE:
      return '#FFF4E5';
    case CardTheme.NEUTRAL:
      return '#F5F5F5';
    case CardTheme.BLUE_LIGHT:
      return '#E5F4FF';
    case CardTheme.PURPLE_LIGHT:
      return '#F5E5FF';
    case CardTheme.GREEN:
      return '#E5FFE5';
    case CardTheme.BLUE:
      return '#E5F0FF';
    case CardTheme.PURPLE:
      return '#EDE5FF';
    case CardTheme.PINK:
      return '#FFE5F5';
    case CardTheme.TEAL:
      return '#E5FFF5';
    default:
      return '#F5F5F5';
  }
};

export const InternalDashboardCard: FC<InternalDashboardCardProps> = ({ item, isLoading }) => {
  const { icon, title, count, theme } = item;

  if (isLoading) {
    return (
      <div className='bg-white rounded-lg border border-neutral-20 p-16 flex flex-col items-start gap-12 h-full'>
        <div className='w-40 h-40 rounded-full bg-neutral-10 animate-pulse' />
        <div className='w-16 h-24 bg-neutral-10 rounded animate-pulse' />
        <div className='w-full h-16 bg-neutral-10 rounded animate-pulse' />
      </div>
    );
  }

  const bgColor = getThemeBackgroundColor(theme);

  return (
    <div
      className='bg-white rounded-lg border border-neutral-20 p-16 flex flex-col items-start gap-12 h-full transition-shadow'
      style={{ boxShadow: '0 4px 7px 0 rgba(112, 149, 221, 0.12), 0 2px 0 0 #DFDFDF' }}
    >
      {/* Icon with circular background */}
      <div className='w-40 h-40 rounded-full flex items-center justify-center' style={{ backgroundColor: bgColor }}>
        <img src={icon} alt={typeof title === 'string' ? title : 'Card icon'} className='w-20 h-20 object-contain' />
      </div>

      {/* Count */}
      <h4 className='text-[20px] font-bold text-neutral-100 leading-none'>{count}</h4>

      {/* Title */}
      <p className='text-xs text-neutral-60 leading-tight'>{title}</p>
    </div>
  );
};
